export default "__VITE_ASSET__CgTtNDT5__"